import { isServer } from '@/helpers';

export type SettingsState = { isWhitelabel: boolean };

function getInitialState(): SettingsState {
  if (isServer) return { isWhitelabel: false };
  return { isWhitelabel: sessionStorage.getItem('whitelabel') === 'true' };
}

const initialState: SettingsState = getInitialState();

export function settings(state = initialState) {
  return state;
}
